namespace RioERP.Orders {
    export namespace FranchiseePaymentsService {
        export const baseUrl = 'Orders/FranchiseePayments';

        export declare function Create(request: Serenity.SaveRequest<FranchiseePaymentsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<FranchiseePaymentsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<FranchiseePaymentsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FranchiseePaymentsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetTotalShare(request: FranchiseePayoutRequest, onSuccess?: (response: FranchiseePayoutResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/FranchiseePayments/Create",
            Update = "Orders/FranchiseePayments/Update",
            Delete = "Orders/FranchiseePayments/Delete",
            Retrieve = "Orders/FranchiseePayments/Retrieve",
            List = "Orders/FranchiseePayments/List",
            GetTotalShare = "Orders/FranchiseePayments/GetTotalShare"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetTotalShare'
        ].forEach(x => {
            (<any>FranchiseePaymentsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
